var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTryAgain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6493 3.34902C12.0193 1.71902 9.70929 0.779016 7.16929 1.03902C3.49929 1.40902 0.479289 4.38902 0.0692889 8.05902C-0.480711 12.909 3.26929 16.999 7.99929 16.999C11.1893 16.999 13.9293 15.129 15.2093 12.439C15.5293 11.769 15.0493 10.999 14.3093 10.999C13.9393 10.999 13.5893 11.199 13.4293 11.529C12.2993 13.959 9.58929 15.499 6.62929 14.839C4.40929 14.349 2.61929 12.539 2.14929 10.319C1.30929 6.43902 4.25929 2.99902 7.99929 2.99902C9.65929 2.99902 11.1393 3.68902 12.2193 4.77902L10.7093 6.28902C10.0793 6.91902 10.5193 7.99902 11.4093 7.99902H14.9993C15.5493 7.99902 15.9993 7.54902 15.9993 6.99902V3.40902C15.9993 2.51902 14.9193 2.06902 14.2893 2.69902L13.6493 3.34902Z",
    fill: "#4D4184"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTryAgain);
export default __webpack_public_path__ + "static/media/tryAgain.08c099b6e02dfe6c231eea491b3749f1.svg";
export { ForwardRef as ReactComponent };